<section class="table-content">

  <div class="filters">
    <input (input)="getSubjects('search', search)" [(ngModel)]="search" type="search" name="search" id="search"
           placeholder="Search name, username...">

    <div>
      @if (loggedUserRole === 'SUPER_ADMIN' && schools() !== null) {
        <select (change)="getSubjects('school_id', filterSchoolId)" [(ngModel)]="filterSchoolId" name="schoolId"
                id="schoolId">
          <option value="" hidden disabled>Select a school</option>
          <option value="">All School</option>


          @for (s of schools()?.payload; track $index) {
            <option [value]="s.id">{{ Helpers.capitalizeWords(s.school_name) }}</option>
          }

        </select>
      }

      <select (change)="getSubjects('status', status)" [(ngModel)]="status" name="status" id="status">
        <option value="" hidden disabled>Select a status</option>
        <option value="">All Statuses</option>

        <option value="ACTIVE">Active</option>
        <option value="INACTIVE">Inactive</option>
        <option value="ARCHIVED">Archived</option>
      </select>
    </div>
  </div>

  <div class="table-wrapper">
    <table>
      <thead>
      <tr>
        <th>SUBJECT ID</th>
        <th>NAME</th>
        <th>CODE</th>
        <th>STATUS</th>
        <th class="options-column">ACTIONS</th>
      </tr>
      </thead>

      <tbody>
        @if (isFiltering()) {
          <td colspan="5">
            <app-loading-indicator />
          </td>
        } @else {
          @if (!subjects()?.payload?.length) {
            <tr>
              <td colspan="5" class="empty">
                <app-not-found-error>
                  NO SUBJECTS FOUND
                </app-not-found-error>
              </td>
            </tr>
          } @else {
            @for (u of subjects()?.payload; track u.id) {
              <tr>
                <td>
                  {{ u.public_id }}
                </td>

                <td>
                  {{ u.name }}
                </td>

                <td>
                  <p>
                    {{ u.code }}
                  </p>
                </td>

                <td class="status">
                  <p [ngClass]="u.status">{{ Helpers.replaceUnderscore(u.status) }}</p>
                </td>

                <td class="options-column">
                  <app-action-button>
                    <button class="menu-item" (click)="selectSubject('details', u )">View details</button>

                    @if (admins.includes(loggedUserRole ?? '')) {

                      <button class="menu-item" (click)="selectSubject('edit', u )">Edit subject</button>

                      <button class="menu-item" (click)="selectSubject('status', u)">Change status</button>
                    }
                  </app-action-button>
                </td>
              </tr>
            }
          }
        }
      </tbody>
    </table>
  </div>

  <app-pagination
    [page]="subjects()?.pagination?.page ?? 0"
    [size]="subjects()?.pagination?.size ?? 10"
    [totalElements]="subjects()?.pagination?.totalElements ?? 0"
    [totalPages]="subjects()?.pagination?.totalPages ?? 0"
    [first]="subjects()?.pagination?.first ?? true"
    [last]="subjects()?.pagination?.last ?? false"
    [hasNext]="subjects()?.pagination?.hasNext ?? false"
    [hasPrevious]="subjects()?.pagination?.hasPrevious ?? false"
    (pageChange)="loadPage($event)">
  </app-pagination>

</section>

@if (changeStatus()) {
  <section class="pop-up">
    <div class="bg" (click)="changeStatus.set(false)"></div>

    <form #changeStatusForm="ngForm" (ngSubmit)="editAcademicYearFn(changeStatusForm, 'status')">
      <div class="form-heading">
        <div class="image-box">
          <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" enable-background="new 0 0 52 52" xml:space="preserve" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M20,37.5c0-0.8-0.7-1.5-1.5-1.5h-15C2.7,36,2,36.7,2,37.5v11C2,49.3,2.7,50,3.5,50h15c0.8,0,1.5-0.7,1.5-1.5 V37.5z"></path> <path d="M8.1,22H3.2c-1,0-1.5,0.9-0.9,1.4l8,8.3c0.4,0.3,1,0.3,1.4,0l8-8.3c0.6-0.6,0.1-1.4-0.9-1.4h-4.7 c0-5,4.9-10,9.9-10V6C15,6,8.1,13,8.1,22z"></path> <path d="M41.8,20.3c-0.4-0.3-1-0.3-1.4,0l-8,8.3c-0.6,0.6-0.1,1.4,0.9,1.4h4.8c0,6-4.1,10-10.1,10v6 c9,0,16.1-7,16.1-16H49c1,0,1.5-0.9,0.9-1.4L41.8,20.3z"></path> <path d="M50,3.5C50,2.7,49.3,2,48.5,2h-15C32.7,2,32,2.7,32,3.5v11c0,0.8,0.7,1.5,1.5,1.5h15c0.8,0,1.5-0.7,1.5-1.5 V3.5z"></path> </g></svg>
        </div>
        <div>
          <h6>Change Status</h6>
          <small>Updating status of {{ selectedSubject.name }}</small>
        </div>
      </div>

      <div class="form-container">
        <div class="status">
          <small>Current status:</small>
          <p [ngClass]="selectedSubject.status">{{ selectedSubject.status }}</p>
        </div>

        <div>
          <label for="status">New Status <span class="required-check">*</span></label>
          <select required [(ngModel)]="status" name="status" id="status">
            <option value="" hidden disabled>Select a status</option>

            @for (s of validStatuses; track $index) {
              @if (s !== selectedSubject.status) {
                <option [value]="s">{{ Helpers.toSentenceCase(Helpers.replaceUnderscore(s)) }}</option>
              }
            }
          </select>
        </div>


        <button class="secondary-button" [disabled]="changeStatusForm.invalid" type="submit">
          @if (isEditing()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Change status
          }
        </button>

      </div>
    </form>
  </section>
}

@if (editSubject()) {
  <section class="pop-up">
    <div class="bg" (click)="editSubject.set(false)"></div>

    <form #subjectForm="ngForm" (ngSubmit)="editAcademicYearFn(subjectForm, 'edit')">
      <div class="form-heading">
        <div class="image-box">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 10.4V20M12 10.4C12 8.15979 12 7.03969 11.564 6.18404C11.1805 5.43139 10.5686 4.81947 9.81596 4.43597C8.96031 4 7.84021 4 5.6 4H4.6C4.03995 4 3.75992 4 3.54601 4.10899C3.35785 4.20487 3.20487 4.35785 3.10899 4.54601C3 4.75992 3 5.03995 3 5.6V16.4C3 16.9601 3 17.2401 3.10899 17.454C3.20487 17.6422 3.35785 17.7951 3.54601 17.891C3.75992 18 4.03995 18 4.6 18H7.54668C8.08687 18 8.35696 18 8.61814 18.0466C8.84995 18.0879 9.0761 18.1563 9.29191 18.2506C9.53504 18.3567 9.75977 18.5065 10.2092 18.8062L12 20M12 10.4C12 8.15979 12 7.03969 12.436 6.18404C12.8195 5.43139 13.4314 4.81947 14.184 4.43597C15.0397 4 16.1598 4 18.4 4H19.4C19.9601 4 20.2401 4 20.454 4.10899C20.6422 4.20487 20.7951 4.35785 20.891 4.54601C21 4.75992 21 5.03995 21 5.6V16.4C21 16.9601 21 17.2401 20.891 17.454C20.7951 17.6422 20.6422 17.7951 20.454 17.891C20.2401 18 19.9601 18 19.4 18H16.4533C15.9131 18 15.643 18 15.3819 18.0466C15.15 18.0879 14.9239 18.1563 14.7081 18.2506C14.465 18.3567 14.2402 18.5065 13.7908 18.8062L12 20" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
        </div>
        <div>
          <h6>Update a Subject</h6>
          <small>Adjust Subject details</small>
        </div>
      </div>

      <div class="form-container">
        <div>
          <label for="nameOfSubject">Name of Subject <span class="required-check">*</span></label>
          <input placeholder="e.g. Mathematics" required [(ngModel)]="nameOfSubject" type="text" name="nameOfSubject"
                 id="nameOfSubject">
        </div>

        <div>
          <label for="subjectCode">Code <span class="required-check">*</span></label>
          <input placeholder="e.g. MATH 101" required [(ngModel)]="subjectCode" type="text" name="subjectCode"
                 id="subjectCode">
        </div>

        <div>
          <label for="subjectDescription">Description</label>
          <input placeholder="e.g. The study of numbers, shapes, quantities, and patterns..."
                 [(ngModel)]="subjectDescription"
                 type="text" name="subjectDescription" id="subjectDescription">
        </div>


        <button class="secondary-button" [disabled]="subjectForm.invalid">
          @if (isEditing()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Update details
          }
        </button>
      </div>

    </form>
  </section>
}

<section [class.show]="showDetail()" class="slider">
  <div class="bg" (click)="showDetail.set(false)"></div>

  <div class="slider-content">
    <div class="slider-heading">
      <div>
        <h5>{{ selectedSubject.name }}</h5>
        <small>{{ selectedSubject.public_id }}</small>
      </div>

      <div class="status">
        <p [ngClass]="selectedSubject.status">{{ Helpers.replaceUnderscore(selectedSubject.status) }}</p>
      </div>
    </div>

    <div class="transaction-info">
      <h6>SUBJECT DETAILS</h6>

      <div class="transaction-container">
        <div>
          <small>Subject ID</small>
          <p>{{ selectedSubject.public_id}}</p>
        </div>

        <div>
          <small>Subject Code </small>
          <p>{{ selectedSubject.code}}</p>
        </div>

        <div>
          <small>Description</small>
          <p>{{ selectedSubject.description}}</p>
        </div>

      </div>
    </div>

    <div class="fee-summary">
      <h6>LEVELS OFFERING THIS SUBJECT</h6>

      @if (!levelSubjects()?.payload?.length) {
        <h3 class="error">NO LEVEL OFFERS THIS SUBJECT CURRENTLY</h3>
      } @else {

      <div class="level-container">
        @for (l of levelSubjects()?.payload; track $index) {
          <div class="level-row">
            <h6>{{l.level_code}}</h6>

            <div class="level-name">
              <p>{{l.level_name}}</p>
              <small>{{l.public_id}}</small>
            </div>

            <div class="status">
              <p [ngClass]="l.status">{{l.status}}</p>
            </div>
          </div>
        }
      </div>
      }
    </div>

    <div class="fee-summary subject-teacher">
      <h6>SUBJECT TEACHERS BY CLASS</h6>

      @if (!teacherClassSubjects()?.payload?.length) {
        <h3 class="error">NO TEACHER HAS BEEN ASSIGNED CURRENTLY</h3>
      } @else {
        <div class="level-container">
          @for (l of teacherClassSubjects()?.payload; track $index) {
            <div class="level-row class-teacher">
              <h6>{{Helpers.getInitials(l.teacher_first_name + ' ' + l.teacher_last_name)}}</h6>

              <div class="level-name">
                <p>{{ l.level_name }}{{ l.class_name }}</p>
                <small>{{ l.teacher_first_name }} {{ l.teacher_last_name }}</small>
              </div>

              <p class="academic-year">{{ l.academic_year_name }}</p>
            </div>
          }
        </div>
      }

    </div>

    @if (admins.includes(loggedUserRole ?? '')) {
      <div class="button-container">
        <button (click)="openAssignSubjectToLevels()" class="button assign-levels" type="button">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M8 21V12L4.5 8L10.5 4C10.8 3.8 11 3.8 11 3.8L13.5 2L16 2L21 6H18.5H17V7.5H18.5V12L21 4V2L16.5 6.5V3L13.5 6V21" stroke="#fff" stroke-width="2" stroke-linejoin="round" /></g></svg>
          Assign Subject to Level
        </button>

        <button (click)="openAssignSubjectToTeacher()" class="button assign-subject" type="button">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 10.4V20M12 10.4C12 8.15979 12 7.03969 11.564 6.18404C11.1805 5.43139 10.5686 4.81947 9.81596 4.43597C8.96031 4 7.84021 4 5.6 4H4.6C4.03995 4 3.75992 4 3.54601 4.10899C3.35785 4.20487 3.20487 4.35785 3.10899 4.54601C3 4.75992 3 5.03995 3 5.6V16.4C3 16.9601 3 17.2401 3.10899 17.454C3.20487 17.6422 3.35785 17.7951 3.54601 17.891C3.75992 18 4.03995 18 4.6 18H7.54668C8.08687 18 8.35696 18 8.61814 18.0466C8.84995 18.0879 9.0761 18.1563 9.29191 18.2506C9.53504 18.3567 9.75977 18.5065 10.2092 18.8062L12 20M12 10.4C12 8.15979 12 7.03969 12.436 6.18404C12.8195 5.43139 13.4314 4.81947 14.184 4.43597C15.0397 4 16.1598 4 18.4 4H19.4C19.9601 4 20.2401 4 20.454 4.10899C20.6422 4.20487 20.7951 4.35785 20.891 4.54601C21 4.75992 21 5.03995 21 5.6V16.4C21 16.9601 21 17.2401 20.891 17.454C20.7951 17.6422 20.6422 17.7951 20.454 17.891C20.2401 18 19.9601 18 19.4 18H16.4533C15.9131 18 15.643 18 15.3819 18.0466C15.15 18.0879 14.9239 18.1563 14.7081 18.2506C14.465 18.3567 14.2402 18.5065 13.7908 18.8062L12 20" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
          Assign Teacher to Subject
        </button>
      </div>
    }

  </div>
</section>

@if (assignLevelPopup()) {
  <section class="pop-up">
    <div class="bg" (click)="assignLevelPopup.set(false)"></div>

    <form #assignLevelForm="ngForm" (ngSubmit)="assignSubjectToLevels()">
      <div class="form-heading">
        <div class="image-box">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M8 21V12L4.5 8L10.5 4C10.8 3.8 11 3.8 11 3.8L13.5 2L16 2L21 6H18.5H17V7.5H18.5V12L21 4V2L16.5 6.5V3L13.5 6V21" stroke="#fff" stroke-width="2" stroke-linejoin="round" /></g></svg>
        </div>

        <div>
          <h6>Assign {{ selectedSubject.name }} to Levels</h6>
          <small>Select the levels this subject should be assigned to</small>
        </div>
      </div>

      <div class="form-container">
        <div class="levels-field">
          <label>Select Levels</label>

          <div class="levels-grid">
            <div class="level-option select-all" [class.selected]="areAllLevelsSelected" (click)="selectAllLevels()">
              <div class="level-checkbox">
                @if (areAllLevelsSelected) {
                  <span>✓</span>
                }
              </div>

              <span class="level-name">Select All</span>
            </div>

            @for (level of levels()?.payload; track level.id) {
              <div class="level-option" [class.selected]="selectedLevels.includes(level.id)" (click)="selectLevel(level.id)">
                <div class="level-checkbox">
                  @if (selectedLevels.includes(level.id)) {
                    <span>✓</span>
                  }
                </div>

                <span class="level-name">{{ level.name }}</span>
              </div>
            }
          </div>
        </div>

        <button [disabled]="!selectedLevels.length" class="secondary-button" type="submit">
          @if (isAssigning()) {
            <app-loading-indicator />
          } @else {
            Assign Subject to Levels
          }
        </button>
      </div>
    </form>
  </section>
}

@if (assignSubjectTeacherCheck()) {
  <section class="pop-up">
    <div class="bg" (click)="assignSubjectTeacherCheck.set(false)"></div>

    <form #subjectTeacherForm="ngForm" (ngSubmit)="assignSubjectToTeacherFn(subjectTeacherForm)">
      <div class="form-heading">
        <div class="image-box">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.4865 13.1108V11.8622C12.4865 11.1998 12.2234 10.5646 11.7551 10.0963C11.2867 9.62798 10.6515 9.36487 9.98921 9.36487H4.99461C4.33229 9.36487 3.69709 9.62798 3.22876 10.0963C2.76042 10.5646 2.49731 11.1998 2.49731 11.8622V13.1108"
              stroke="white" stroke-width="1.37352" />
            <path
              d="M7.49193 6.86759C8.87115 6.86759 9.98923 5.74951 9.98923 4.37029C9.98923 2.99107 8.87115 1.87299 7.49193 1.87299C6.11271 1.87299 4.99463 2.99107 4.99463 4.37029C4.99463 5.74951 6.11271 6.86759 7.49193 6.86759Z"
              stroke="white" stroke-width="1.37352" />
          </svg>
        </div>
        <div>
          <h6>Assign a Teacher to {{ selectedSubject.name }}</h6>
          <small>Teachers can be assigned to classes or subjects</small>
        </div>
      </div>

      <div class="form-container">
        <div>
          <label for="academicYearId">Academic Year <span class="required-check">*</span></label>
          <select (change)="onAcademicYearChange()" required [(ngModel)]="selectedAcademicYearId"
                  name="academicYearId" id="academicYearId">
            <option value="" disabled>Select an academic year</option>

            @for (a of academicYears()?.payload; track a.id) {
              <option [value]="a.id">{{ a.name }}</option>
            }
          </select>
        </div>

        @if (selectedAcademicYearId && selectedAcademicYearId !== '') {
          <div>
          <label for="selectedClassId">Class <span class="required-check">*</span></label>
          <select required [(ngModel)]="selectedClassId" name="selectedClassId" id="selectedClassId">
            <option value="" disabled>Select a class</option>
            @for (c of classList()?.payload; track c.id) {
              <option [value]="c.id">{{ c.level_name }}{{ c.name }}</option>
            }
          </select>
        </div>
        }

        <div class="user-query">
          <label for="query">Search Teacher <span class="required-check">*</span></label>
          <input (input)="getTeachers(query)" [(ngModel)]="query" type="search" name="query" id="query"
                 placeholder="Search name, staff id or username...">

          @if (teachers()?.payload?.length && query !== '') {
            <ul>
              @for (t of teachers()?.payload; track t.id) {
                @if (!invalidStatuses.includes(t.status)) {
                  <li (click)="selectTeacher(t)">
                    <h6>{{
                        Helpers.fullName({
                          first_name: t.first_name,
                          last_name: t.last_name,
                        })
                      }}
                    </h6>
                    <p>Teacher ID: {{ t.public_id }}</p>
                  </li>
                }
              }
            </ul>
          }
        </div>

        @if (teacherName) {
          <div class="user-card">
            <div class="heading">
              <svg fill="#fff" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier"><title>school</title>
                  <path
                    d="M30 21.25h-6.25v-8.957l5.877 3.358c0.107 0.062 0.236 0.098 0.373 0.099h0c0.414-0.001 0.749-0.336 0.749-0.751 0-0.277-0.15-0.519-0.373-0.649l-0.004-0.002-13.623-7.784v-0.552c0.172 0.016 0.35 0.068 0.519 0.068 0.004 0 0.010 0 0.015 0 0.475 0 0.934-0.067 1.368-0.193l-0.035 0.009c0.323-0.063 0.693-0.099 1.073-0.099 0.392 0 0.775 0.039 1.146 0.112l-0.037-0.006c0.039 0.007 0.083 0.012 0.129 0.012 0.184 0 0.352-0.068 0.479-0.181l-0.001 0.001c0.161-0.139 0.263-0.343 0.264-0.571v-2.812c0 0 0-0 0-0 0-0.355-0.247-0.653-0.579-0.73l-0.005-0.001c-0.419-0.111-0.9-0.176-1.396-0.176-0.5 0-0.985 0.065-1.446 0.187l0.039-0.009c-0.288 0.067-0.618 0.105-0.958 0.105-0.231 0-0.457-0.018-0.678-0.052l0.025 0.003c-0.122-0.256-0.378-0.43-0.676-0.43-0.412 0-0.746 0.334-0.746 0.746 0 0.001 0 0.003 0 0.004v-0 4.565l-13.622 7.784c-0.227 0.132-0.378 0.374-0.378 0.651 0 0.414 0.336 0.75 0.75 0.75 0.137 0 0.265-0.037 0.376-0.101l-0.004 0.002 5.878-3.359v8.957h-6.25c-0.414 0-0.75 0.336-0.75 0.75v0 8c0 0.414 0.336 0.75 0.75 0.75h28c0.414-0 0.75-0.336 0.75-0.75v0-8c-0-0.414-0.336-0.75-0.75-0.75v0zM18.658 3.075c0.298-0.082 0.64-0.13 0.993-0.13 0.183 0 0.363 0.013 0.539 0.037l-0.020-0.002v1.339c-0.16-0.013-0.345-0.021-0.533-0.021-0.489 0-0.966 0.052-1.425 0.151l0.044-0.008c-0.304 0.088-0.653 0.139-1.014 0.139-0.174 0-0.344-0.012-0.512-0.034l0.020 0.002v-1.323c0.15 0.014 0.325 0.021 0.502 0.021 0.499 0 0.984-0.062 1.447-0.18l-0.041 0.009zM2.75 22.75h5.5v6.5h-5.5zM9.75 22v-10.564l6.25-3.571 6.25 3.572v17.814h-2.5v-5.25c-0-0.414-0.336-0.75-0.75-0.75h-6c-0.414 0-0.75 0.336-0.75 0.75v0 5.25h-2.5zM13.75 29.25v-4.5h4.5v4.5zM29.25 29.25h-5.5v-6.5h5.5zM16 19.75c2.071 0 3.75-1.679 3.75-3.75s-1.679-3.75-3.75-3.75c-2.071 0-3.75 1.679-3.75 3.75v0c0.002 2.070 1.68 3.748 3.75 3.75h0zM16 13.75c1.243 0 2.25 1.007 2.25 2.25s-1.007 2.25-2.25 2.25c-1.243 0-2.25-1.007-2.25-2.25v0c0.002-1.242 1.008-2.248 2.25-2.25h0z"></path>
                </g>
              </svg>
              <h4>Selected Teacher</h4>
            </div>
            <div class="user-content">
              <p>TEACHER NAME</p>
              <p>TEACHER ID</p>
              <h5>{{ teacherName }}</h5>
              <h5>{{ teacherPublicId }}</h5>
            </div>
          </div>
        }

        <div>
          <label for="assignmentRole">Teacher Role <span class="required-check">*</span></label>
          <select required [(ngModel)]="assignmentRole" name="assignmentRole" id="assignmentRole">
            <option value="" disabled hidden>Select a role</option>
            <option value="LEAD">Lead</option>
            <option value="ASSISTANT">Assistant</option>
            <option value="SUBSTITUTE">Substitute</option>
          </select>
        </div>

        <button [disabled]="subjectTeacherForm.invalid || !classTeacherId" class="secondary-button" type="submit">
          @if (isAssigning()) {
            <app-loading-indicator />
          } @else {
            Assign Subject Teacher
          }
        </button>
      </div>
    </form>
  </section>
}


